import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../../assets/images/webp/blulake_logo.webp';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMenuClosing, setIsMenuClosing] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    if (isMenuOpen) {
      setIsMenuClosing(true);
      setTimeout(() => {
        setIsMenuOpen(false);
        setIsMenuClosing(false);
      }, 800); // Match the closing animation duration
    } else {
      setIsMenuOpen(true);
    }
  };

  const isActive = (path: string) => location.pathname === path;

  // Enhanced glass effect on scroll - Vatican Cathedral inspired elegance
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-wrapper">
          <Link to="/">
            <img src={logo} alt="BlueLake" />
          </Link>
          <div className="menu">
            <Link to="/" className={isActive('/') ? 'active' : ''}>Home</Link>
            <Link to="/about" className={isActive('/about') ? 'active' : ''}>About</Link>
            <Link to="/portfolio" className={isActive('/portfolio') ? 'active' : ''}>Portfolio</Link>
            <Link to="/services" className={isActive('/services') ? 'active' : ''}>Services</Link>
            <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link>
            <a href="https://portal.bluelake.id">Client Portal</a>
          </div>
          <div className={`button ${isMenuOpen ? 'buttonActive' : ''}`} onClick={toggleMenu}>
            <div className={`burger ${isMenuOpen ? 'burgerActive' : ''}`}>
              <span className="line"></span>
              <span className="line"></span>
            </div>
          </div>
        </div>
      </nav>
      
      {(isMenuOpen || isMenuClosing) && (
        <div className={`expanded-wrapper ${isMenuClosing ? 'closing' : ''}`}>
          <div className="expanded-menu">
            <div className="menu-list">
              <Link to="/" onClick={toggleMenu} className={isActive('/') ? 'active' : ''}>Home</Link>
              <Link to="/about" onClick={toggleMenu} className={isActive('/about') ? 'active' : ''}>About</Link>
              <Link to="/portfolio" onClick={toggleMenu} className={isActive('/portfolio') ? 'active' : ''}>Portfolio</Link>
              <Link to="/services" onClick={toggleMenu} className={isActive('/services') ? 'active' : ''}>Services</Link>
              <Link to="/contact" onClick={toggleMenu} className={isActive('/contact') ? 'active' : ''}>Contact</Link>
              <a href="https://portal.bluelake.id">Client Portal</a>
            </div>
            <div className="close-button" onClick={toggleMenu}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;